import { CircularProgress, Stack, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { MFIUserTablePropsType } from "../../../types/container.type";
import DeleteIcon from '@mui/icons-material/Delete';
import { BaseButton } from "../../../components/button/styled";

export const MFIUserTable: React.FC<MFIUserTablePropsType> = ({ rows, handleItemClick, selectedMFIUserId }) => {
    const MFIUserTableHeaders = ["First Name", "Last Name", "User Role", "Branch", "Action"];
    return (
        <BaseTable
            headers={MFIUserTableHeaders}
        >
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow
                            key={index}
                        >
                            <TableCell>{row?.firstName}</TableCell>
                            <TableCell>{row?.lastName}</TableCell>
                            <TableCell>{row?.roles?.[row?.roles?.length - 1]?.title}</TableCell>
                            <TableCell>{row?.branch.name || "None"}</TableCell>
                            <TableCell>
                                <Stack
                                    direction={"row"}
                                    gap={"calc(var(--flex-gap)/4)"}
                                >
                                    <BaseButton
                                        variant="contained"
                                        bgcolor="var(--primary-color)"
                                        padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
                                        fontweight={500}
                                        fontsize={"14px"}
                                        onClick={(e) => handleItemClick?.(e, row.id, "edit")}
                                    >
                                        <Typography
                                            variant={"button"}
                                            fontFamily={"inherit"}
                                            fontWeight={"inherit"}
                                            fontSize={"inherit"}
                                            lineHeight={"inherit"}
                                            color={"inherit"}
                                            textTransform={"inherit"}
                                        >
                                            Edit
                                        </Typography>
                                    </BaseButton>
                                    <BaseButton
                                        variant="contained"
                                        bgcolor="var(--text-salmon-pink-color)"
                                        padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
                                        fontweight={500}
                                        fontsize={"14px"}
                                        onClick={(e) => handleItemClick?.(e, { mfiUserId: row.id, institutionId: row.institution }, "delete")}
                                    >
                                        {(selectedMFIUserId !== null && selectedMFIUserId === row.id) ? (
                                            <CircularProgress color="inherit" className="loader" />
                                        ) : (
                                            <DeleteIcon />
                                        )}
                                    </BaseButton>
                                </Stack>
                            </TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}